import {
  InsidePageContainer,
  StyledTooltip,
  getExhibitorsV2Translations,
} from '../common';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useHistory } from 'react-router-dom';
import React, { useContext, useEffect } from 'react';
import { LoaderContext } from 'context/LoaderContextProvider';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  useMediaQuery,
  useTheme,
  Stack,
  Typography,
  Dialog,
  Button,
} from '@mui/material';
import { WhitePageContainer, StyledChip } from '../common';
import { useIntl } from 'react-intl';
import {
  StyledAppBar,
  BackButton,
  RedLinkButton,
  Image,
  ImageContainer,
  Overlay,
  TextButton,
} from './styles';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AddIcon from '@mui/icons-material/Add';
import MapOutlined from '@mui/icons-material/MapOutlined';
import { useState } from 'react';
import { ExhibitorContext } from 'context/ExhibitorContextProvider';
import { LoaderCountContext } from 'context/LoaderV5';
import { useNetwork } from 'services/network';
import { useDataHelper } from 'utils/dataHelper';
import {
  Roles,
  backHomeLink,
  defaultLang,
  defaultSearchYear,
  isBookingBrandActive,
  isMapBrandActive,
  isPostEvent,
} from 'utils/constants';
import { useRef } from 'react';
import {
  AppointmentDialog,
  MapDialog,
  RegisterSection,
} from '../common/Dialog';
import {
  VisitStatusEnum,
  useBookmarkSelector,
  useBookmarkStore,
  useBookmarks,
} from 'pages/exhibitor/exhibitorBookmarks';
import { format } from 'date-fns';
import { FilterContext } from 'context/FilterContextProvider';
import {
  setMapLayerEvent,
  setExhibitorLayerEvent,
  setVirtualPageView,
} from 'utils/dataLayerManager';

const ExhibitorDetail = ({ locale, loggedUser }) => {
  const isOperator = loggedUser.type === Roles.OPERATOR;
  // Hooks
  const theme = useTheme();
  const is1280Up = useMediaQuery(theme.breakpoints.up(1280));
  const is992down = useMediaQuery(theme.breakpoints.down(992));
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));

  const intl = useIntl();
  const i18nDetail =
    getExhibitorsV2Translations(intl).PersonalPage.exhibitorDetail;
  const i18nCommon = getExhibitorsV2Translations(intl).Common;
  const history = useHistory();
  const network = useNetwork();
  const { filter } = useContext(FilterContext);
  const { isLoaderActive, setLoaderActive } = useContext(LoaderCountContext);
  const { incognitoMode } = useContext(ExhibitorContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const {
    isLoaderActive: isLegacyLoaderActive,
    setLoaderActive: setLegacyLoaderActive,
  } = useContext(LoaderContext);
  const {
    addExhibitorToStore,
    exhibitorsManage,
    loggedUserId,
    removeExhibitorFromStore,
    removeExhibitorsFromFolderInStore,
    folders: storeFolders,
  } = useBookmarkSelector();
  const { saveExhibitors, deleteExhibitorsFromFolder } = useBookmarks();
  const hideLegacyLoader = () => setLegacyLoaderActive(false);
  const { getLocalizedParameter } = useDataHelper();
  const linkEmailRef = useRef(null);
  const trimArray = (arr) => arr.map((el) => el.trim());
  const pipeParse = (str) => {
    const array = str.split('|');
    const trimmed = trimArray(array);
    const orderedArr = order(trimmed);
    const orderedTrimmed = trimArray(orderedArr);
    const orderedWithPipe = orderedTrimmed.join(' | ');
    const regex = /( \|)/gm;
    const subst = `; `;
    // The substituted value will be contained in the result variable
    const result = orderedWithPipe.replace(regex, subst);
    return result;
  };

  const compare = (a, b) => {
    if (a.trim() < b.trim()) {
      return -1;
    }
    if (a.trim() > b.trim()) {
      return 1;
    }
    return 0;
  };

  const order = (array) => array.sort(compare);

  // States
  const [itineraries, setItineraries] = useState();
  const [fetchedExhibitor, setFetchedExhibitor] = useState();
  const [isRegisterDialogOpen, setIsRegisterDialogOpen] = useState(false);
  const [registerCtx, setRegisterCtx] = useState('');
  const [isBookDialogOpen, setIsBookDialogOpen] = useState(false);
  const [exhibitorData, setExhibitorData] = useState();
  const [mapDialogState, setMapDialogState] = useState({
    isOpen: false,
    thematic: '',
  });
  const closeMapDialog = () =>
    setMapDialogState({
      isOpen: false,
      thematic: '',
    });
  const closeBookDialog = () => setIsBookDialogOpen(false);

  const showActions = fetchedExhibitor?.hall && fetchedExhibitor?.stand;
  const disableBook =
    (!fetchedExhibitor?.prenotazioneAppuntamenti &&
      !fetchedExhibitor?.appuntamenti) ||
    !fetchedExhibitor?.salesforceId;

  // Effects
  useEffect(() => {
    if (isLegacyLoaderActive) hideLegacyLoader();
  }, [isLegacyLoaderActive]);

  useEffect(() => {
    useBookmarkStore.setState({
      isEditing: false,
      cardsToManage: [],
      currentFolderOnView: null,
    });
  }, []);

  useEffect(() => {
    if (fetchedExhibitor) {
      setVirtualPageView({
        params: `/${fetchedExhibitor.name}`,
        pageTitle: `exhibitors: ${fetchedExhibitor.name}`,
      });
    }
  }, [fetchedExhibitor]);

  useEffect(() => {
    if (
      filter &&
      filter?.percorsi_tematici &&
      fetchedExhibitor?.percorsiTematici &&
      !itineraries
    ) {
      const itineriesArray = fetchedExhibitor.percorsiTematici
        .split('|')
        .map((el) => {
          const trimmed = el.trim();
          return {
            value: trimmed,
            label: filter?.percorsi_tematici?.find(
              (fil) => fil.code === trimmed
            )?.label,
          };
        })
        .filter((el) => !!el.label);
      if (itineriesArray?.length) {
        setItineraries(itineriesArray);
      } else {
        setItineraries([]);
      }
    }
  }, [filter, itineraries, fetchedExhibitor]);

  // Functions
  const handleBack = () => {
    const params = new URLSearchParams(location.search);
    const brandId = params.get('salesforce_id');
    if (brandId) window.location.href = `${backHomeLink}/${locale}/exhibitors`;
    const historyState = history.location.state;
    const state = {
      oldFilters: { ...historyState.oldFilters },
    };

    history.push('/', state);
  };
  const onContactClicked = () => {
    linkEmailRef.current.click();
    setExhibitorLayerEvent({
      event: 'contact_exhibitor',
      exhibitorName: fetchedExhibitor.name,
    });
  };
  const onCalendarClicked = () => {
    if (incognitoMode) {
      setRegisterCtx('calendar');
      return setIsRegisterDialogOpen(true);
    }
    setIsBookDialogOpen(true);
  };
  const onToVisitClicked = () => {
    if (incognitoMode) {
      setRegisterCtx('visit');
      return setIsRegisterDialogOpen(true);
    }
    addExhibitorToStore({
      exhibitor: { ...fetchedExhibitor, status: VisitStatusEnum.TO_VISIT },
    });
    saveExhibitors({
      salesforceId: loggedUserId,
      status: VisitStatusEnum.TO_VISIT,
      exhibitorsIds: [fetchedExhibitor.salesforceId],
    });
  };

  const removeFromToVisit = async () => {
    const exInFolder = storeFolders?.find((f) =>
      f.exhibitors.includes(fetchedExhibitor?.salesforceId)
    );
    if (exInFolder) {
      await deleteExhibitorsFromFolder({
        useLoader: false,
        salesforceId: loggedUserId,
        folderId: exInFolder.folderId,
        exhibitorsIds: [fetchedExhibitor?.salesforceId],
      });
      removeExhibitorsFromFolderInStore({
        folderId: exInFolder.folderId,
        exhibitors: [fetchedExhibitor?.salesforceId],
      });
    }
    removeExhibitorFromStore({
      id: fetchedExhibitor?.salesforceId,
    });
    saveExhibitors({
      salesforceId: loggedUserId,
      status: VisitStatusEnum.NONE,
      exhibitorsIds: [fetchedExhibitor?.salesforceId],
    });
  };

  const onMapClicked = () => {
    setMapLayerEvent({
      event: 'popup_open',
      popup_name: 'salone_del_mobile_map',
    });

    setMapDialogState({ isOpen: true, thematic: '' });
  };

  const isAlreadyInVisit = !!exhibitorsManage?.find(
    (ex) => ex.salesforceId === fetchedExhibitor?.salesforceId
  );

  // Effects
  useEffect(() => {
    if (!fetchedExhibitor) fetchExhibitor();
    else fetchExhibitorData();
  }, [fetchedExhibitor]);

  const fetchExhibitor = async () => {
    showLoader();
    if (history.location.state && history.location.state.exhibitor) {
      setFetchedExhibitor(history.location.state.exhibitor);
      hideLoader();
    } else {
      handleBack();
    }
  };

  const fetchExhibitorData = async () => {
    try {
      const res = await network.get(
        `${network.getBaseUrl(false)}/api/brand/${
          fetchedExhibitor.linkedAccountId
        }/${locale}`
      );
      if (res?.data?.[0]) {
        setExhibitorData({
          coverImage: res.data[0]?.field_cover_export.url,
          pageUrl: res.data[0]?.url,
        });
      }
    } catch (error) {
      console.error(error);
    }
    hideLoader();
  };

  const closeAlert = (sev) =>
    useBookmarkStore.setState({ alertData: { severity: sev } });

  const showAlert = ({ sev = 'success', title = '' }) =>
    useBookmarkStore.setState({
      alertData: {
        title: title,
        onClose: () => closeAlert(sev),
        severity: sev,
      },
    });

  const onAppointmentSubmit = async (data) => {
    closeBookDialog();
    let error = true;
    if (!fetchedExhibitor.appuntamenti) {
      showLoader();
      const input = {
        userSalesforceId: loggedUser.salId,
        brandName: fetchedExhibitor.name,
        brandSalesforceId: fetchedExhibitor.salesforceId,
        brandEmail: fetchedExhibitor.emailDigitale,
        date: format(new Date(data?.date?.value), 'dd/MM/yyyy'),
        startTime: data?.morningStart || '9:30',
        slotTime: data?.slotTime?.value || 30,
        language: data?.language?.value,
        phone: data.phone,
        company: data.company,
        reason: data.reason,
        stand: fetchedExhibitor.stand || 'N.A.',
        pavillion: fetchedExhibitor.hall || 'N.A.',
      };
      const bookingRes = await network.agendaLambda(input, '/createProposal');
      hideLoader();
      showAlert({
        sev: !bookingRes ? 'error' : 'success',
        title: !bookingRes
          ? 'Something went wrong, pleade try again later'
          : 'Request sent successfully',
      });
    } else {
      showLoader();
      try {
        const input = {
          brandName: fetchedExhibitor.name,
          brandSalesforceId: fetchedExhibitor.salesforceId,
          brandEmail: fetchedExhibitor.emailDigitale,
          userSalesforceId: loggedUser.salId,
          slotId: data.time.value,
          language: data.language.value,
          phone: data.phone,
          company: data.company,
          reason: data.reason,
          stand: fetchedExhibitor.stand || 'N.A.',
          pavillion: fetchedExhibitor.hall || 'N.A.',
          type: 'WithDate',
        };
        const res = await network.agendaLambda(input, '/create');
        error = res.error;
      } catch (error) {
        console.error('LOG::  ~ error', error);
      } finally {
        hideLoader();
        showAlert({
          sev: error ? 'error' : 'success',
          title: error
            ? 'Something went wrong, pleade try again later'
            : 'Request sent successfully',
        });
      }
    }
  };

  // renders
  const Header = () => (
    <InsidePageContainer
      sx={{
        padding: 0,
        ...(isMdDown && {
          width: '100%',
        }),
      }}
    >
      <Stack
        flexDirection={isMdDown ? 'column' : 'row'}
        justifyContent={isMdDown ? 'center' : 'space-between'}
        alignItems={'center'}
        width={'100%'}
        gap={isMdDown && '20px'}
      >
        <div>
          <BackButton
            backFn={() => handleBack()}
            backMsg={`${i18nDetail.backToExhibitorList} ${defaultSearchYear}`}
          />
        </div>
        <Stack
          flexDirection={'row'}
          gap={is992down ? '10px' : '30px'}
          sx={{
            ...(isMdDown && {
              width: '100%',
              justifyContent: 'space-between',
            }),
          }}
        >
          <a
            href={`mailto:${fetchedExhibitor?.email}`}
            target="_blank"
            rel="noreferrer"
            hidden
            ref={linkEmailRef}
            onClick={(event) => event.stopPropagation()}
          />
          <RedLinkButton
            onClick={() => fetchedExhibitor?.email && onContactClicked()}
            leftIcon={
              <MailOutlineIcon
                color="primary"
                style={{ width: '20px', height: '20px' }}
              />
            }
            msg={i18nDetail.contactButton}
          />
          {isBookingBrandActive &&
          (isOperator || incognitoMode) &&
          showActions ? (
            <>
              {disableBook ? (
                <StyledTooltip
                  title={i18nCommon.tooltips.disableBook}
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -22],
                          },
                        },
                      ],
                    },
                  }}
                  arrow
                  placement="bottom"
                >
                  <Button
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    sx={{
                      backgroundColor: 'transparent',
                      padding: '0px',
                      border: '0px',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    <RedLinkButton
                      disabled={disableBook}
                      onClick={() => {}}
                      leftIcon={
                        fetchedExhibitor.appuntamenti ? (
                          <CalendarTodayOutlinedIcon
                            color="primary"
                            style={{
                              width: '20px',
                              height: '20px',
                              ...(disableBook && {
                                color: '#E2001A',
                                // color: '#EC0E00',
                                opacity: 0.2,
                              }),
                            }}
                          />
                        ) : (
                          <EditCalendarIcon
                            color="primary"
                            style={{
                              width: '20px',
                              height: '20px',
                              ...(disableBook && {
                                color: '#E2001A',
                                // color: '#EC0E00',
                                opacity: 0.2,
                              }),
                            }}
                          />
                        )
                      }
                      msg={
                        isMdDown
                          ? i18nDetail.book
                          : i18nDetail.bookAppointmentButton
                      }
                    />
                  </Button>
                </StyledTooltip>
              ) : (
                <RedLinkButton
                  onClick={() => onCalendarClicked()}
                  leftIcon={
                    fetchedExhibitor.appuntamenti ? (
                      <CalendarTodayOutlinedIcon
                        color="primary"
                        style={{ width: '20px', height: '20px' }}
                      />
                    ) : (
                      <EditCalendarIcon
                        color="primary"
                        style={{ width: '20px', height: '20px' }}
                      />
                    )
                  }
                  msg={
                    isMdDown
                      ? i18nDetail.book
                      : i18nDetail.bookAppointmentButton
                  }
                />
              )}
            </>
          ) : null}
          {showActions ? (
            <>
              {!isPostEvent ? (
                <>
                  {isAlreadyInVisit ? (
                    <RedLinkButton
                      onClick={() => isAlreadyInVisit && removeFromToVisit()}
                      msg={i18nCommon.addToList}
                      leftIcon={
                        <CheckCircleIcon fontSize="small" color="primary" />
                      }
                    />
                  ) : (
                    <RedLinkButton
                      onClick={() => !isAlreadyInVisit && onToVisitClicked()}
                      leftIcon={
                        <AddIcon
                          color="primary"
                          style={{
                            width: '15px',
                            height: '15px',
                          }}
                        />
                      }
                      msg={i18nCommon.toVisit}
                    />
                  )}
                </>
              ) : null}
            </>
          ) : null}
          {showActions && isMapBrandActive ? (
            <RedLinkButton
              msg={i18nCommon.map}
              onClick={() => onMapClicked()}
              leftIcon={
                <MapOutlined
                  color="primary"
                  style={{ width: '20px', height: '20px' }}
                />
              }
              variant="link2"
            />
          ) : null}
        </Stack>
      </Stack>
    </InsidePageContainer>
  );

  const ElevationScroll = () => {
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
      target: undefined,
    });
    return (
      <StyledAppBar
        position="sticky"
        elevation={trigger ? 4 : 0}
        sx={{
          zIndex: 99,
          ...(trigger && {
            top: is1280Up ? 80 : isSmDown ? '6%' : isXsDown ? 0 : '8%',
          }),
        }}
      >
        <Toolbar
          style={{
            ...(isMdDown && {
              justifyContent: 'center',
            }),
            padding: isSmDown ? '30px 15px' : '25px 70px',
          }}
        >
          <Header />
        </Toolbar>
      </StyledAppBar>
    );
  };

  const handleItinerary = (itineraryCode) =>
    setMapDialogState({ isOpen: true, thematic: itineraryCode });

  return (
    <div
      style={
        isMdDown
          ? { padding: '0 !important' }
          : { padding: '15px 70px 40px 70px !important' }
      }
    >
      {!isLoaderActive && fetchedExhibitor && (
        <>
          <ElevationScroll />
          <InsidePageContainer
            style={{ marginTop: !isMdDown ? '32px' : '0px' }}
          >
            <WhitePageContainer
              gap={isMdDown ? '20px' : '40px !important'}
              margin={'0px'}
              paddingTop={'0px !important'}
            >
              <Stack alignItems={'center'} justifyItems={'center'}>
                <Typography
                  variant={isSmDown ? 'l' : 'xxl'}
                  component="h1"
                  fontWeight={isMdDown && 600}
                >
                  {fetchedExhibitor.name}
                </Typography>
                <Typography color={theme.palette.grey[900]} variant={'body1'}>
                  {fetchedExhibitor?.event} {fetchedExhibitor?.hall ? '|' : ''}{' '}
                  {fetchedExhibitor?.hall && fetchedExhibitor?.hall}{' '}
                  {fetchedExhibitor?.stand ? '|' : ''} {fetchedExhibitor?.stand}
                </Typography>
              </Stack>
              <Stack gap={isMdDown ? '20px' : '25px '}>
                <Stack
                  flexDirection={isMdDown ? 'column' : 'row'}
                  gap={'25px'}
                  alignItems={isMdDown ? 'flex-start' : 'center'}
                >
                  <Stack flexDirection={'row'} gap={isMdDown ? '5px' : '25px'}>
                    {itineraries?.length ? (
                      <>
                        {itineraries.map((iti, idx) => (
                          <StyledChip
                            key={idx}
                            label={
                              <Typography variant="xs-bold">
                                {iti.label}
                              </Typography>
                            }
                            size="small"
                            style={{
                              cursor: iti.value ? 'pointer' : 'default',
                            }}
                            onClick={() => handleItinerary(iti.value)}
                          />
                        ))}
                      </>
                    ) : null}
                  </Stack>
                </Stack>
                <Stack
                  flexDirection={isMdDown ? 'column' : 'row'}
                  gap={isMdDown ? '15px' : '40px'}
                >
                  {isMdDown ? (
                    <Typography
                      color={theme.palette.grey[900]}
                      variant="body2"
                    >{`${fetchedExhibitor.indirizzo} ${fetchedExhibitor.comune} ${fetchedExhibitor.cap} ${fetchedExhibitor?.nation}`}</Typography>
                  ) : (
                    <Stack>
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="body2"
                      >
                        {fetchedExhibitor.indirizzo}
                      </Typography>
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="body2"
                      >
                        {fetchedExhibitor.comune}
                      </Typography>
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="body2"
                      >{`${fetchedExhibitor.cap} ${fetchedExhibitor?.nation}`}</Typography>
                    </Stack>
                  )}
                  <Stack gap={isMdDown && '15px'}>
                    <Typography color={theme.palette.grey[900]} variant="body2">
                      {'Tel:'}
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="link2-bold"
                        style={{ textDecoration: 'underline' }}
                        onClick={() => {}}
                      >
                        {fetchedExhibitor.phone}
                      </Typography>
                    </Typography>
                    {!isMdDown && (
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="body2"
                      >
                        {fetchedExhibitor.fax}
                      </Typography>
                    )}
                    <Typography
                      color={theme.palette.grey[900]}
                      variant="body2-bold"
                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() =>
                        window.open(
                          `https://${fetchedExhibitor.website}`,
                          '_blank'
                        )
                      }
                    >
                      {fetchedExhibitor.website}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              {(fetchedExhibitor[`categorie_${locale}`] ||
                fetchedExhibitor[`categorie_${defaultLang}`]) && (
                <Stack gap={'20px'}>
                  <Typography variant="xl" component="h2">
                    {i18nCommon.categories}
                  </Typography>
                  <Typography color={theme.palette.grey[900]} variant="body2">
                    {pipeParse(
                      getLocalizedParameter(
                        fetchedExhibitor,
                        'categorie',
                        locale
                      )
                    )}
                  </Typography>
                </Stack>
              )}
              {(fetchedExhibitor[`prodotti_${locale}`] ||
                fetchedExhibitor[`prodotti_${defaultLang}`]) && (
                <Stack gap={'20px'}>
                  <Typography variant="xl" component="h2">
                    {i18nCommon.products}
                  </Typography>
                  <Typography color={theme.palette.grey[900]} variant="body2">
                    {pipeParse(
                      getLocalizedParameter(
                        fetchedExhibitor,
                        'prodotti',
                        locale
                      )
                    )}
                  </Typography>
                </Stack>
              )}
              {exhibitorData?.pageUrl ? (
                <div
                  style={{
                    width: `${isXsDown ? 90 : 100}%`,
                    margin: '0 auto',
                    maxHeight: 586,
                  }}
                >
                  <ImageContainer>
                    <Image alt="" src={exhibitorData.coverImage} />
                    <Overlay>
                      <Typography
                        color={theme.palette.grey[900]}
                        variant="l"
                        textAlign={'center'}
                        style={{
                          color: 'white',
                          zIndex: '30',
                          padding: `0 ${isXsDown ? 0 : 30}px`,
                        }}
                      >
                        {i18nDetail.visitBrandPage}
                      </Typography>
                      <Typography
                        color={theme.palette.grey[900]}
                        variant={'body1'}
                        textAlign={'center'}
                        style={{
                          color: 'white',
                          width: `100%`,
                          margin: '0 auto',
                          marginBottom: '20px',
                        }}
                      >
                        {i18nDetail.findMore}
                      </Typography>
                      <a
                        href={exhibitorData.pageUrl}
                        style={{
                          backgroundColor: theme.palette.primary.main,
                          zIndex: 50,
                          margin: 4,
                          textDecoration: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        <TextButton
                          text={i18nDetail.visitBrandPage}
                          variant={'body1'}
                        />
                      </a>
                    </Overlay>
                  </ImageContainer>
                </div>
              ) : null}
            </WhitePageContainer>
          </InsidePageContainer>
        </>
      )}
      <Dialog
        open={isRegisterDialogOpen}
        onClose={() => {
          setRegisterCtx('');
          setIsRegisterDialogOpen(false);
        }}
        PaperProps={{
          style: {
            padding: 40,
            maxWidth: 720,
            borderRadius: '12px',
          },
        }}
      >
        <RegisterSection
          isSmDown={isSmDown}
          onClose={() => {
            setRegisterCtx('');
            setIsRegisterDialogOpen(false);
          }}
          locale={locale}
          ctx={registerCtx}
        />
      </Dialog>
      <AppointmentDialog
        isOpen={isBookDialogOpen}
        onClose={() => closeBookDialog()}
        exhibitor={fetchedExhibitor}
        loggedUser={loggedUser}
        onSubmit={onAppointmentSubmit}
      />
      <MapDialog
        isOpen={mapDialogState.isOpen}
        onClose={() => closeMapDialog()}
        exhibitor={fetchedExhibitor}
        locale={locale}
        thematic={mapDialogState.thematic}
        token={loggedUser ? '&token=' + loggedUser.tk : ''}
      />
    </div>
  );
};

export default ExhibitorDetail;
